exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    height: 30px;\r\n    text-align: right;\r\n    padding-top: 4px;\r\n    color: #888;\r\n    flex-grow: 0;\r\n    flex-shrink: 0;\r\n}\r\n\r\ndiv {\r\n    display: inline;\r\n    margin-left: 34px;\r\n}\r\n\r\na {\r\n    text-decoration: none;\r\n}\r\n\r\n.top-image {\r\n    width: 18px;\r\n    height: 18px;\r\n    margin-left: 8px;\r\n    vertical-align: middle;\r\n}\r\n\r\n.flag-image {\r\n    width: 22px;\r\n    height: 16px;\r\n    vertical-align: middle;\r\n    /*margin-right: -16px;*/\r\n}\r\n\r\nspan.glyphicon {\r\n    margin-left: 4px;\r\n    font-size: 11px;\r\n}\r\n\r\n.sign-out {\r\n    margin-left: 12px;\r\n    cursor: pointer;\r\n}\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/top-bar/top-bar.component.css
// module id = 1865
// module chunks = 1